module.exports = __webpack_public_path__ + "static/media/libro1.ae0428d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro1.png
// module id = 204
// module chunks = 0